<template>
  <div>
    <PreviewAppendix
      :dataContract="dataContract"
      :dataAppendix="dataAppendix"
      :dataConfig="dataConfig"
      :srcPDF="srcPDF"
      showAction
      @confirm="conFirmHD"
    >
      <template #append-main>
        <div
          v-if="dataAppendix?.state === 'WAITING_SIGN' && dataAppendix?.isRemote"
          class="d-flex justify-content-between align-items-center mt-3 p-2 bg-white rounded custom-confirm-nl"
        >
          <div>
            <b-checkbox v-model="isAccept"
              >Tôi đã đọc và xác nhận các thông tin trên là chính xác.</b-checkbox
            >
            <small>Quý khách vui lòng kiểm tra lại các thông tin trên trước khi xác nhận.</small>
          </div>
          <div class="d-flex gap-2" style="gap: 10px">
            <!-- <b-button variant="danger" @click="conFirmHD(false)">Từ chối</b-button> -->
            <b-button variant="primary" :disabled="!isAccept" @click="showPopupConfirmNganLuong"
              >Ký xác nhận</b-button
            >
          </div>
        </div>
      </template>
    </PreviewAppendix>
    <PopupConfirmNganLuong
      ref="popupConfirmNganLuongRef"
      :id="dataAppendix?.appendixId || ''"
      :email="dataContract?.customerInfoCommon?.email || ''"
      :mobile="dataContract?.customerInfoCommon?.mobile || ''"
      :token="token"
      @hide="onPopupHide"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { ReviewService } from '@/services/review.service'
  import { ContractService } from '@/services/contract.service'
  import PreviewAppendix from '@/pages/contract/component/preview/preview-appendix'
  import PopupConfirmNganLuong from '@/pages/nganluong/popup-confirm/index.vue'

  export default {
    data() {
      return {
        dataContract: {},
        dataAppendix: {},
        dataConfig: {},
        showLoading: true,
        srcPDF: null,
        isAccept: false,
        token: '',
      }
    },

    components: { PreviewAppendix, PopupConfirmNganLuong },
    async created() {
      try {
        const param = this.$route.query
        const { contractId, version, codeVerify, token, appendixId } = this.$route.query
        this.token = token
        if (!param || !contractId || !version || !codeVerify || !token || !appendixId) {
          alert('Thông tin không hợp lệ !')
          return
        }
        const dataApendix = await ReviewService.getApendixById_V2({
          appendixId: appendixId,
          token: token,
        })
        if (dataApendix.code !== 1000) {
          throw dataApendix
        }
        this.dataAppendix = dataApendix.data

        const response = await ContractService.getDetailContractByID_V2({
          contractId: contractId,
          token: token,
        })
        if (response.code === 1000) {
          this.dataContract = response.data
          if (this.dataContract.typeCustomer && this.dataContract.typeCustomer === 'COMPANY') {
            await this.getLinkPDFBusinessContract()
          }
          this.checkAppendix(this.dataAppendix.typeAppendix)
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.showLoading = false
      }
    },

    methods: {
      async conFirmHD(state) {
        try {
          this.showLoading = true
          const { contractId, token, appendixId } = this.$route.query
          if (appendixId && appendixId !== '') {
            let responses = {}
            if (
              this.dataAppendix.typeCustomer &&
              this.dataAppendix.typeCustomer === 'COMPANY' &&
              state
            ) {
              responses = await this.genPDF_Megadoc_Appendix(state)
            } else {
              responses = await ReviewService.comfirmActionAppendix({
                data: {
                  appendixId: appendixId,
                  appendixActionType: state ? 'APPENDIX_ACTION_APPROVE' : 'APPENDIX_ACTION_REJECT',
                },
                token: token,
              })
            }

            if (responses.data.result) {
              if (!this.dataAppendix?.isRemote) {
                this.showSuccessMx(responses.data.message)
              }

              this.getAppendix()

              const dataContractRespon = await ContractService.getDetailContractByID_V2({
                contractId: contractId,
                token: token,
              })
              if (dataContractRespon.code === 1000) {
                this.dataContract = dataContractRespon.data
                if (
                  this.dataContract?.typeCustomer !== 'COMPANY' &&
                  this.dataAppendix?.state === 'WAITING_SIGN' &&
                  this.dataAppendix?.isRemote
                ) {
                  this.$refs.popupConfirmNganLuongRef.show()
                }
                return
              } else {
                alert('Mã hợp đồng không hợp lệ !')
              }
            } else {
              this.showFailMx(responses.data.message)
            }
          }
        } catch (err) {
          console.log(err)
          alert('Đã xảy ra lỗi')
        } finally {
          this.showLoading = false
        }
      },

      async genPDF_Megadoc_Appendix(state) {
        let data = {}
        const { appendixId, token } = this.$route.query
        this.showLoading = true
        const bodyReqMegadoc = {
          token: token,
          code: this.dataContract.code,
          appendixId: appendixId,
          typeAppendix: Config.mappingTypeAppendix[this.dataAppendix.typeAppendix],
          groupService: this.dataContract.groupService,
        }
        const response = await ContractService.genPDF_Megadoc_Appendix(bodyReqMegadoc)
        if (response.code === 1000) {
          const bodyReqActionAppendix = {
            appendixId: appendixId,
            appendixActionType: state ? 'APPENDIX_ACTION_APPROVE' : 'APPENDIX_ACTION_REJECT',
            urlS3: `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/file/${response.message}`,
          }
          data = await ReviewService.comfirmActionAppendix({
            data: bodyReqActionAppendix,
            token: token,
          })
        } else {
          this.showFailMx(response.message)
        }
        return data
      },

      async getLinkPDFBusinessContract() {
        try {
          const { token, appendixId } = this.$route.query
          const body = {
            contractId: '',
            appendixId,
            token,
          }
          const data = await ReviewService.getLinkPDFBusinessContract(body)
          if (data.code === 1000) {
            const start = data.message.indexOf('accessKeyS3=')

            const accessKeyS3 = data.message.substring(start + 12, data.message.length)
            const body = {
              appendixId,
              accessKeyS3: accessKeyS3,
            }
            const dataContractRespon = await ContractService.getLinkPDF(body)
            if (dataContractRespon.success) {
              this.srcPDF = `${dataContractRespon.data.urlContractS3}?key=${accessKeyS3}`
            }
          } else {
            console.log(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getAppendix() {
        const { appendixId, token } = this.$route.query
        const dataApendix = await ReviewService.getApendixById_V2({
          appendixId: appendixId,
          token: token,
        })
        if (dataApendix.code !== 1000) {
          throw dataApendix
        }
        this.dataAppendix = dataApendix.data
      },

      async checkAppendix(typeAppendix) {
        const keyChildMap = {
          CREDIT: 3,
          DEVICE: 4,
          TRANS: 2,
          LIQUIDATE: 6,
          TRANSFER: 7,
          PACKAGE: 5,
          CASHBACK: 8,
          RECALL: 9,
          HAND_OVER: 10,
          QR: 11,
          LEND: 12,
          ONUS: 13,
          CHANGE: 14,
          RENT: 15,
          HOME_PAY_LATER: 16,
          LINK_CARD: 17,
          QR_CONNECTOR: 18,
          NGANLUONG_CONVERT: 19,
        }
        this.dataConfig = {
          keyChild: keyChildMap[typeAppendix] || 0,
          title: Config.typeAppendix.find(s => s.id === typeAppendix)?.text,
        }
      },
      showPopupConfirmNganLuong() {
        this.$refs.popupConfirmNganLuongRef.show()
      },
      async onPopupHide(isSuccess) {
        if (isSuccess) {
          this.getAppendix()
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  :deep(.custom-control-label) {
    padding-top: 5px;
  }
  .custom-confirm-nl {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    button {
      min-width: 110px;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column !important;
      align-items: flex-start !important;
      padding-bottom: max(15px, env(safe-area-inset-bottom)) !important;

      > div:first-child {
        margin-bottom: 12px;
      }

      > div:last-child {
        width: 100%;
        justify-content: center;

        button {
          width: 100%;
        }
      }
    }
  }
</style>
